import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export interface VasMerchantIntegrationDto {
  merchantUser: boolean;
  vasIntegrationReady: boolean;
  statusMessage?: string | null;
  merchantUserId?: number | null;
  brandMerchantId?: number | null;
  phoneNumber?: string | null;
  email?: string | null;
  username?: string | null;
  mappedServiceEnumId?: string | null;
  ruleConfigId?: number | null;
  serviceId?: string | null;
  ruleConfigActive?: boolean | null;
  submissionsPaused?: boolean | null;
  shadowMode?: boolean | null;
  numbersToSelect?: number | null;
  numberRange?: number | null;
  dailyPriceNgn?: number | null;
  entryCloseMinutesBeforeDraw?: number | null;
  entryWindowTriggerMinutesBeforeDraw?: number | null;
  availableServiceIds?: string[] | null;
  triggerWebhookConfigured?: boolean | null;
  triggerWebhookEnabled?: boolean | null;
  triggerWebhookUrl?: string | null;
}

export async function getVasIntegrationInfo(): Promise<VasMerchantIntegrationDto> {
  const res = await api.get("users/vas-integration-info", null);
  return res as VasMerchantIntegrationDto;
}

export interface MerchantLotterySlotRow {
  id?: number;
  slotTitle?: string;
  title?: string;
  state?: string;
  numbersToSelect?: number;
  numberRange?: number;
  isVasSlot?: boolean;
  gameId?: number;
}

export async function getMerchantLotterySlots(): Promise<MerchantLotterySlotRow[]> {
  const res = await api.get("merchant/lottery-games", null);
  return Array.isArray(res) ? (res as MerchantLotterySlotRow[]) : [];
}

export async function patchMerchantServiceRule(body: {
  serviceId?: string;
  numbersToSelect?: number;
  numberRange?: number;
  entryCloseMinutesBeforeDraw?: number;
  entryWindowTriggerMinutesBeforeDraw?: number;
}): Promise<unknown> {
  return api.update("merchant/service-rule-config", body);
}
